import React from "react";
import MainNavigation from "../components/MainNavigation";
import { useRouteError } from "react-router-dom";
/**
 * @author
 * @function ErrorPage
 **/

const ErrorPage = ({ jwt }) => {
  const error = useRouteError();

  return (
    <>
      <MainNavigation jwt={jwt} />
      <main>
        <h1>404 - This page Not Found</h1>
        <p>{error.message}</p>
      </main>
    </>
  );
};

export default ErrorPage;
